import { authAPI } from './auth';
import type { BriefingIntent } from '../utils/briefingIntent';

export const briefingIntentAPI = {
  claim: (token: string) => authAPI.claimBriefingIntent(token) as Promise<{ intent: BriefingIntent }>,
  pending: () => authAPI.getPendingBriefingIntent() as Promise<{ intent: BriefingIntent | null }>,
  projectCreated: (id: string, projectId: string) => authAPI.markBriefingIntentProjectCreated(id, projectId),
  complete: (id: string) => authAPI.completeBriefingIntent(id),
  dismiss: (id: string) => authAPI.dismissBriefingIntent(id),
};
